import React, { useEffect, useState } from "react";
import { Modal, Carousel } from "react-bootstrap";
import "./About.css";
import aboutHero1 from "../assets/aboutHero1.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import travel3 from "../assets/travel3.jpg";
import travel4 from "../assets/travel4.jpg";
import travel5 from "../assets/travel5.jpg";
import travel6 from "../assets/travel6.jpg";
import travel7 from "../assets/travel7.jpg";
import travel8 from "../assets/travel8.jpg";
import travel10 from "../assets/travel10.jpg";
import travel13 from "../assets/travel13.jpg";
import travel14 from "../assets/travel14.jpg";
import travel15 from "../assets/travel15.jpg";
import travelRoad1 from "../assets/travelRoad1.jpg";
import travelRoad2 from "../assets/travelRoad2.jpg";
import travelRoad3 from "../assets/travelRoad3.jpg";
import travelFace1 from "../assets/travelFace1.jpg";
import travelColour1 from "../assets/travelColour1.jpg";
import travelFace_1 from "../assets/travelFace_1.jpg";
import travelFace_2 from "../assets/travelFace_2.jpg";
import travelFace_3 from "../assets/travelFace_3.jpg";
import travelFace_4 from "../assets/travelFace_4.jpg";
import travelFace_5 from "../assets/travelFace_5.jpg";
import travel_whisper1 from "../assets/travel_whisper1.jpg";
import travel_whisper2 from "../assets/travel_whisper2.jpg";
import travel_whisper3 from "../assets/travel_whisper3.jpg";
import travel_whisper4 from "../assets/travel_whisper4.jpg";
import travel_whisper5 from "../assets/travel_whisper5.jpg";
import travel_color from "../assets/travel_color.jpg";
import travel_roads1 from "../assets/travel_roads1.jpg";
import travel_roads2 from "../assets/travel_roads2.jpg";
import travel_roads3 from "../assets/travel_roads3.jpg";
import travel_roads4 from "../assets/travel_roads4.jpg";
import travel_roads5 from "../assets/travel_roads5.jpg";
import travel_roads6 from "../assets/travel_roads6.jpg";
import travel_roads7 from "../assets/travel_roads7.jpg";
import travel_roads8 from "../assets/travel_roads8.jpg";
import travel_roads9 from "../assets/travel_roads9.jpg";
import travel_roads10 from "../assets/travel_roads10.jpg";
import travel_roads11 from "../assets/travel_roads11.jpg";
import travel_roads12 from "../assets/travel_roads12.jpg";
import travel_roads13 from "../assets/travel_roads13.jpg";
import travel_echo1 from "../assets/travel_echo1.jpg";
import travel_echo2 from "../assets/travel_echo2.jpg";
import travel_echo3 from "../assets/travel_echo3.jpg";
import travel_echo4 from "../assets/travel_echo4.jpg";
import travel_echo5 from "../assets/travel_echo5.jpg";
import travel_echo6 from "../assets/travel_echo6.jpg";
import travel_echo7 from "../assets/travel_echo7.jpg";
import travel_echo8 from "../assets/travel_echo8.jpg";
import travel_echo9 from "../assets/travel_echo9.jpg";
import travel_echo10 from "../assets/travel_echo10.jpg";
import travel_echo11 from "../assets/travel_echo11.jpg";
import travel_echo12 from "../assets/travel_echo12.jpg";

const About = () => {

  const [showModal, setShowModal] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animate only once
      disable: 'mobile' // disable on mobile devices
    });
  }, []);

  const handleShowModal = (images) => {
    setCarouselImages(images);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="about-page bg-black text-light">

      {/* ==================== Photographer Intro Section ==================== */}
      <section className="photographer-intro py-5" data-aos="zoom-in">
        <div className="container">
          <div className="row align-items-center justify-content-center">

            {/* Left: Portrait Collage */}
            <div className="col-lg-5 col-md-10 text-center mb-4 mb-lg-0">
              <div className="photo-collage">
                <img src={aboutHero1} alt="Photographer" className="main-photo" />
                {/* <img src={aboutHero3} alt="Photographer at work" className="side-photo top" /> */}
                {/* <img src={aboutHero2} alt="Behind the scenes" className="side-photo bottom" /> */}
              </div>
            </div>

            {/* Right: Bio Text */}
            <div className="col-lg-6 col-md-10">
              <h2 className="fw-bold mb-3 position-relative intro-heading">
                About Me
              </h2>
              <div className="red-underline mb-4"></div>

              <p className="about-text">
                Hi, I’m <strong className="text-danger">Navaneeth</strong> — a passionate visual storyteller with over
                <strong> 7 years of experience</strong> behind the camera. Photography, for me, is not just about capturing images;
                it’s about freezing emotions, love, and life’s most beautiful moments into timeless frames.
              </p>

              <p className="about-text">
                My journey began with a simple love for storytelling through visuals, and today,
                I specialize in <strong>Weddings and Pre-Wedding, Portrait and Lifestyle Photography</strong>.
                I believe every couple and every person has a story to tell — one that deserves to be preserved forever.
              </p>

              <p className="about-text">
                Beyond photography, I'm an avid travel enthusiast,constantly seeking new horizons and cultures to explore Whether it's chasing golden hour light in remote locations,documenting vibrant city scapes,
                or immersing myself in diverse traditions, my camera is always in hand,ready to turn fleeting moments into timeless memories.
              </p>

              <p className="about-text">
                Photography, to me, isn’t just a profession — it’s a heartfelt way of connecting with people,
                celebrating emotions, and capturing stories that stay alive for generations.
              </p>

              <p className="about-text mt-4">
                <em>Best regards,</em><br />
                <strong className="text-danger fs-5">Navaneeth</strong>
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* ==================== TRAVEL TALES SECTION ==================== */}
      <section className="travel-tales py-5">
        <div className="container">
          <h2
            className="section-title text-center mb-5 text-uppercase"
            data-aos="zoom-in">
            🌍 Travel Stories Through My Lens 💫
          </h2>

          {/* ===== SECTION 1 ===== */}
          <div
            className="travel-story d-flex flex-column flex-md-row align-items-center mb-5"
            data-aos="zoom-in">
            <div className="travel-gallery gallery-left order-1 order-md-1">
              <div className="photo-grid">
                <div
                  className="photo large hover-overlay"
                  onClick={() =>
                    handleShowModal([travel4, travel7, travelFace1, travelFace_1, travelFace_2, travelFace_3, travelFace_4, travelFace_5])
                  }
                >
                  <img src={travel4} alt="Travel 4" />
                  <button className="view-more-btn">View More Pics</button>
                </div>
                <div className="photo small">
                  <img src={travel7} alt="Travel 7" />
                </div>
                <div className="photo small">
                  <img src={travelFace1} alt="Travel Face" />
                </div>
              </div>
            </div>
            <div className="travel-text order-2 order-md-2 ms-md-5 mt-4 mt-md-0">
              <h4 className="text-danger fw-bold mb-3">Faces of the Journey</h4>
              <p>
                Every portrait holds an untold story — emotions of people met
                along the way, fleeting glances, and smiles that connect souls
                across cultures. Each frame is a window to humanity, framed
                through light and emotion.
              </p>
            </div>
          </div>

          {/* ===== SECTION 2 ===== */}
          <div
            className="travel-story d-flex flex-column flex-md-row align-items-center mb-5"
            data-aos="zoom-in">
            <div className="travel-text order-2 order-md-1 me-md-5 mt-4 mt-md-0">
              <h4 className="text-danger fw-bold mb-3">Whispers of Heritage</h4>
              <p>
                Ancient walls and monuments stand tall as silent witnesses of
                time. From the golden dusk over forts to reflections in rivers,
                every structure tells a tale of legacy through the
                photographer’s vision.
              </p>
            </div>
            <div className="travel-gallery gallery-right order-1 order-md-2">
              <div className="photo-grid">
                <div
                  className="photo large hover-overlay"
                  onClick={() =>
                    handleShowModal([travel10, travel5, travel6, travel_whisper2, travel_whisper3, travel_whisper4, travel_whisper1, travel_whisper5])
                  }
                >
                  <img src={travel10} alt="Travel 10" />
                  <button className="view-more-btn">View More Pics</button>
                </div>
                <div className="photo small">
                  <img src={travel5} alt="Travel 5" />
                </div>
                <div className="photo small">
                  <img src={travel6} alt="Travel 6" />
                </div>
              </div>
            </div>
          </div>

          {/* ===== SECTION 3 ===== */}
          <div
            className="travel-story d-flex flex-column flex-md-row align-items-center mb-5"
            data-aos="zoom-in">
            <div className="travel-gallery gallery-left order-1 order-md-1">
              <div className="photo-grid">
                <div className="photo small">
                  <img src={travelRoad1} alt="Travel Road 1" />
                </div>
                <div className="photo small">
                  <img src={travelRoad2} alt="Travel Road 2" />
                </div>
                <div
                  className="photo large hover-overlay"
                  onClick={() =>
                    handleShowModal([travelRoad1, travelRoad2, travelRoad3, travel_roads1, travel_roads2, travel_roads3, travel_roads4, travel_roads5, travel_roads6, travel_roads7, travel_roads8, travel_roads9, travel_roads10, travel_roads11, travel_roads12, travel_roads13])
                  }>
                  <img src={travelRoad3} alt="Travel Road 3" />
                  <button className="view-more-btn">View More Pics</button>
                </div>
              </div>
            </div>
            <div className="travel-text order-2 order-md-2 ms-md-5 mt-4 mt-md-0">
              <h4 className="text-danger fw-bold mb-3">Roads Less Traveled</h4>
              <p>
                Beyond cityscapes lie raw, untouched stories of wanderlust —
                winding roads, solitary trees, and silent horizons. Every
                photograph captures freedom and peace.
              </p>
            </div>
          </div>

          {/* ===== SECTION 4 ===== */}
          <div
            className="travel-story d-flex flex-column flex-md-row align-items-center mb-5"
            data-aos="zoom-in">
            <div className="travel-text order-2 order-md-1 me-md-5 mt-4 mt-md-0">
              <h4 className="text-danger fw-bold mb-3">Colors of Culture</h4>
              <p>
                The world is painted in colors — festivals, traditions, and
                rituals captured through light and perspective. These moments
                celebrate diversity and emotion in their purest form.
              </p>
            </div>
            <div className="travel-gallery gallery-right order-1 order-md-2">
              <div className="photo-grid">
                <div className="photo small">
                  <img src={travel3} alt="Travel 3" />
                </div>
                <div className="photo small">
                  <img src={travelColour1} alt="Travel Colour" />
                </div>
                <div
                  className="photo large hover-overlay"
                  onClick={() =>
                    handleShowModal([travel8, travel3, travelColour1, travel_color])
                  }
                >
                  <img src={travel8} alt="Travel 8" />
                  <button className="view-more-btn">View More Pics</button>
                </div>
              </div>
            </div>

          </div>

          {/* ===== SECTION 5 ===== */}
          <div
            className="travel-story d-flex flex-column flex-md-row align-items-center mb-5"
            data-aos="zoom-in">
            <div className="travel-gallery gallery-left order-1 order-md-1">
              <div className="photo-grid">
                <div
                  className="photo large hover-overlay"
                  onClick={() =>
                    handleShowModal([travel13, travel14, travel15, travel_echo1, travel_echo2, travel_echo3, travel_echo4, travel_echo5, travel_echo6, travel_echo7, travel_echo8, travel_echo9, travel_echo10, travel_echo11, travel_echo12])
                  }
                >
                  <img src={travel13} alt="Travel 13" />
                  <button className="view-more-btn">View More Pics</button>
                </div>
                <div className="photo small">
                  <img src={travel14} alt="Travel 14" />
                </div>
                <div className="photo small">
                  <img src={travel15} alt="Travel 15" />
                </div>
              </div>
            </div>
            <div className="travel-text order-2 order-md-2 ms-md-5 mt-4 mt-md-0">
              <h4 className="text-danger fw-bold mb-3">Echoes of Time</h4>
              <p>
                The grandeur of ancient monuments whispers tales of forgotten
                kingdoms and timeless artistry. Every arch, pillar, and shadow
                reflects the craftsmanship of eras long gone, yet alive through
                the photographer’s lens.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== MODAL CAROUSEL ===== */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Body className="bg-dark text-center">
          <Carousel>
            {carouselImages.map((img, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100 rounded"
                  src={img}
                  alt={`Slide ${index}`}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default About;
